<div id="mySidenav" *ngIf="permissions">
  <div *ngFor="let nav of navigation" [ngClass]="{isNavVisible: permissions[nav.iconKey] == 'N'}">
    <button [routerLink]="[nav.routeTo]" id="{{nav.id}}" [routerLinkActive]="'onClick'" [routerLinkActiveOptions]="{exact:true}">
      <mat-icon>{{nav.iconName}}</mat-icon>{{nav.iconKey}}
      <div *ngIf="nav.iconKey === 'Messages' && msgCount && msgCount > 0" style="position: relative; display: inline-block;">
        <mat-icon class="notification-bell">notifications_none</mat-icon>
        <!--span class="notification-count">
          {{msgCount}}
        </span-->
      </div>
    </button>
  </div>
 </div>